<footer>
  <div class="row">
    <div class="col-4">
      <a
        href="http://www.mekh.hu"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="languageService.get('mekh_logo_aria_label')"
      >
        <img id="mekh-logo" src="assets/images/MEKH_logo_magyar_feher_atlatszo_1920x590.png" alt="MEKH Logo" width="260" height="80" />
      </a>
      <div class="app-version-right text-end dx-theme-background-color-as-text-color">
        <div>
          <span>TAB Version: {{ appInfo.appVersion }}</span>
        </div>
      </div>
    </div>

    <div class="dx-theme-background-color-as-text-color">
      <span>{{ languageService.get('contact') }}&nbsp;</span>
      <a
        href="mailto:mekh@mekh.hu"
        [attr.aria-label]="languageService.get('mekh_ugyfelszolgalat_aria_label')"
        class="dx-theme-background-color-as-text-color"
        >energiastatisztika&#64;mekh.hu</a
      >
    </div>
  </div>
</footer>
